import { variant } from 'styled-system';

import styled from './styled';

export const fonts = {
  fonts: {
    body:
      'Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif',
    heading:
      'Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif',
    monospace: 'monospace'
  },
  fontWeights: {
    light: 300,
    body: 400,
    bold: 500,
    subheading: 600,
    heading: 700,
    bolder: 700,
    extraBold: 800
  },
  lineHeights: {
    default: 1,
    body: 1.5,
    heading: 1.1,
    subheading: 1.1
  },
  letterSpacings: {
    body: 'normal',
    heading: 'normal'
  },
  fontSizes: [
    8,    // 0
    10.2, // 1
    12.8, // 2
    16,   // 3
    20,   // 4
    25,   // 5
    31.3, // 6
    39.1, // 7
    48.8, // 8
    61,   // 9
    76.3, // 10
    95.4, // 11
    119.2 // 12
  ]
};

export const newHeadings = {
  subheadM700: {
    fontWeight: 'bold',
    fontSize: [4, 5, 7],
    lineHeight: 1.02,
    color: 'coolGrey.100'
  },
  subheadXS700: {
    fontWeight: 'bold',
    fontSize: 5,
    lineHeight: 0.96,
    color: 'coolGrey.100'
  }
};

export const headings = {
  ...newHeadings,
  headlineXL: {
    color: 'heading',
    fontSize: [9, 10, 11, 12],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 8
  },
  headlineL: {
    color: 'heading',
    fontSize: [8, 9, 10, 11],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 8
  },
  headlineM: {
    color: 'heading',
    fontSize: [7, 8, 9, 10],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  headlineS: {
    color: 'heading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  headlineXS: {
    color: 'heading',
    fontSize: [5, 6, 7, 8],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 5
  },
  subheadXL: {
    color: 'subheading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 7
  },
  subheadL: {
    color: 'subheading',
    fontSize: [5, 6, 7, 8],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 6
  },
  subheadM: {
    color: 'subheading',
    fontSize: [4, 5, 6, 7],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 6
  },
  subheadS: {
    color: 'subheading',
    fontSize: [3, 4, 5, 6],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  subheadXS: {
    color: 'subheading',
    fontSize: [2, 3, 4, 5],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  subheadXXS: {
    color: 'subheading',
    fontSize: [2, 3, 3, 4],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 4
  },
  subheadXXXS: {
    color: 'subheading',
    fontSize: [1, 2, 3],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 8
  },
  cardTitle: {
    color: 'heading',
    fontSize: 4,
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0
  }
};

export const newTextStyles = {
  introXS300: {
    fontWeight: 'light',
    fontSize: 4,
    lineHeight: 1.2,
    marginBottom: 4,
    color: 'coolGrey.50'
  },
  bodyS400: {
    fontWeight: 'normal',
    fontSize: 3,
    lineHeight: 'body',
    color: 'coolGrey.100'
  }
};

export const textStyles = {
  ...headings,
  ...newTextStyles,
  callout: {
    fontWeight: 'normal',
    fontSize: [4, 5, 5, 5],
    lineHeight: 'body',
    marginBottom: 5,
    color: 'text'
  },
  body: {
    fontWeight: 'normal',
    fontSize: 4,
    marginBottom: 5,
    color: 'text'
  },
  bodySmall: {
    fontWeight: 'normal',
    fontSize: 3,
    marginBottom: 3,
    color: 'text'
  },
  bodyBold: {
    fontWeight: 'bolder',
    fontSize: 4,
    marginBottom: 3,
    color: 'text'
  },
  bodyInverse: {
    fontWeight: 'normal',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'white'
  },
  navLabel: {
    fontWeight: 'normal',
    fontSize: 2,
    margin: 0,
    padding: 0
  },
  navText: {
    fontWeight: 'normal',
    fontSize: 2,
    margin: 0,
    padding: '4px 0 0 !important'
  },
  navHeader: {
    fontWeight: 'bold',
    fontSize: 3,
    margin: 0,
    padding: '0 !important'
  },
  subhead: {
    fontWeight: 'light',
    fontSize: [4, 4, 5, 5],
    marginBottom: 5
  },
  link: {
    fontSize: 3,
    fontWeight: 'bold',
    color: 'primary'
  },
  card: {
    fontSize: 3,
    fontWeight: 'normal',
    color: 'blueSteel'
  },
  quoteXL: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  quoteL: {
    fontWeight: 'light',
    fontSize: [5, 5, 5, 5, 6],
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  quoteM: {
    fontWeight: 'light',
    fontSize: [4, 4, 4, 4, 5],
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  quoteS: {
    fontWeight: 'light',
    fontSize: 4,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  quoteXS: {
    fontWeight: 'light',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  }
};

// Base so other components can extend and reuse text styles.
export const Text = styled('p')<{ textStyles?: string }>(
  variant({
    prop: 'textStyles',
    variants: {
      ...textStyles
    }
  })
);
